<template>
    <div class="button-wrapper" @click="clickHandler" @mouseover="mouseOverHandler" @mouseout="mouseOutHandler">
        <div class="before-icon" :style="{ background: leftIconBg }" v-if="isShowIcon"></div>
        <div class="text">{{ text }}</div>
        <div class="after-icon" :style="{ background: rightIconBg }" v-if="isShowRightIcon"></div>
    </div>
</template>

<script>
/**
 * emit btnClick
 */
export default {
    name: "Button",
    props: ["text", "icon", "rightIcon", "addData", "hoverIcon", "hoverIconRight"],
    data() {
        return {
            leftIconBg: this.getIconBg(this.icon || ""),
            rightIconBg: this.getIconBg(this.rightIcon || "")
        };
    },
    computed: {
        isShowIcon() {
            return !!this.icon;
        },
        isShowRightIcon() {
            return !!this.rightIcon;
        }
    },
    methods: {
        clickHandler(event) {
            this.$emit("btnClick", {
                event,
                addData: this.addData
            });
        },
        getIconBg(icon) {
            return icon.indexOf("url") != -1 ? icon : "url(" + icon + ")";
        },
        mouseOverHandler() {
            this.hoverIcon && (this.leftIconBg = this.getIconBg(this.hoverIcon));
            this.hoverIconRight && (this.rightIconBg = this.getIconBg(this.hoverIconRight));
        },
        mouseOutHandler() {
            this.leftIconBg = this.getIconBg(this.icon || "");
            this.rightIconBg = this.getIconBg(this.rightIcon || "");
        }
    }
};
</script>

<style lang="less" scoped>
.button-wrapper {
    position: relative;
    border: solid 1px #d8e4f0;
    border-radius: 4px;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    background: #fff;
    display: inline-flex;
    align-items: center;
    color: #41475e;
    user-select: none;
    .text {
        vertical-align: -1px;
    }
    & > div {
        display: inline-block;
        vertical-align: middle;
    }

    .before-icon,
    .after-icon {
        display: inline-block;
        width: 18px;
        height: 18px;
        background-repeat: no-repeat !important;
    }

    .before-icon {
        margin-right: 5px;
        vertical-align: text-bottom;
    }

    .after-icon {
        width: 6px;
        margin-left: 5px;
    }

    &:hover {
        cursor: pointer;
        color: #2ec2ff;
    }

    &:active {
        background: #dee9f2;
    }
}
</style>
